"use client";

import { useState } from "react";
import Image from "next/image";

const AboutAreaTwo = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="who-we-are-area ptb-120">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side */}
          <div className="col-lg-6 col-md-12">
            <div className="who-we-are-content">
              <h2 className="text-uppercase fw-semibold fs-3">Who We Are</h2>
              <p className="justify-clean lh-lg mb-0">
                Ashva Education and Para-medical Organization is Academic Organization Established in the year 2013, mainly deals in promotion of Vocational and Professional and Paramedical Educational programs for the deprived and deserving candidates in the society. Besides Organization works for the upliftment of the people from under-privileged class through developmental work of distinct nature which includes arranging Health and Medical checkup camps for un-served and under-served people through door-steps services, arranging blood Donation camps, Career guidance classes for SSC and HSC passed out students etc.
              </p>
              <div className="funfacts">
                <h3 className="fw-semibold fs-2">
                  250<span>+</span>
                </h3>
                <p className="fw-medium fs-6">Trusted partners</p>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="col-lg-6 col-md-12">
            <div className="who-we-are-image">
              <div className="users">
                <div className="d-flex align-items-center">
                  <Image height={57} width={57} src="/images/users/image1.png" className="rounded-circle" alt="user-image" />
                  <Image height={57} width={57} src="/images/users/image2.png" className="rounded-circle" alt="user-image" />
                  <Image height={57} width={57} src="/images/users/image4.png" className="rounded-circle" alt="user-image" />
                  <Image height={57} width={57} src="/images/users/image3.png" className="rounded-circle" alt="user-image" />
                </div>
                <span className="d-block fw-medium">1000+</span>
                <p>Positive feedback by our students</p>
              </div>

              {/* Video thumbnail */}
              <div className="image position-relative">
                <Image
                  height={247}
                  width={603}
                  src="/images/events/image7.png"
                  alt="who-we-are-image"
                />
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                  }}
                  className="video-btn popup-youtube rounded-circle d-flex align-items-center justify-content-center"
                >
                  <i className="fa-solid fa-play" />
                </a>
              </div>

              {/* Custom Modal */}
              {isOpen && (
                <div className="video-modal">
                  <div className="video-backdrop" onClick={() => setIsOpen(false)} />
                  <div className="video-container">
                    <video
                      src="/images/video/video.mp4"
                      controls
                      autoPlay
                      className="video-player"
                    />
                    <button className="close-btn" onClick={() => setIsOpen(false)}>
                      &times;
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Styles */}
      <style jsx>{`
        .video-modal {
          position: fixed;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        .video-backdrop {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.8);
        }
        .video-container {
          position: relative;
          z-index: 10000;
          max-width: 80%;
          width: 700px;
        }
        .video-player {
          width: 90%;
          border-radius: 10px;
        }
        .close-btn {
          position: absolute;
          top: -35px;
          right: -35px;
          background: transparent;
          border: none;
          font-size: 40px;
          color: #fff;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default AboutAreaTwo;
